import { Component, Input } from '@angular/core';
import { IStyleOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { IPrintPreviewData } from '../../interfaces/IPrintPreviewData.interface';
import { localizationKeys } from '../../provider/localizationKeysDefaultValues';

@Component({
    selector: 'aumico-notes-component-print-preview-deprecated',
    templateUrl: './component-print-preview-deprecated.component.html',
    styleUrls: ['./component-print-preview-deprecated.component.scss'],
})
export class ComponentPrintPreviewComponent {
    @Input() printPreviewData: IPrintPreviewData;
    @Input() currency: string;

    // refer to finNumber pipe for reference on values
    @Input() numberFormat = '1.2-2';
    inWordKey = localizationKeys.aumico_notes_word_in;

    textColor: string;
    backgroundColor: string;
    @Input() set stylePreferenceOptions(value: IStyleOptions) {
        if (value != null) {
            this.textColor = value.textColor;
            this.backgroundColor = value.backgroundColor;
        }
    }

    @Input() noPreviousData: boolean;

    constructor() {}

    isIsoDate(str: string): boolean {
        const hasIsoDateFormat = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str);
        if (!hasIsoDateFormat) {
            return false;
        }
        const date = new Date(str);
        return date.toISOString() === str;
    }

    getNumber(value: string | number): number {
        if (typeof value === 'number') {
            return value;
        }
        return null;
    }

    isOfTypeNumber(value: string | number): boolean {
        if (typeof value === 'number') {
            return true;
        }
        return false;
    }
}
